import { call, put } from 'redux-saga/effects'
import { apiConfig } from '../../../../../config/api-config'
import { makeAccess } from '../../../../../config/factory-controller'
import { JourneyRepository } from '../../../data/repositories/journey-repository'
import { JourneyService } from '../../../service/journey-service'
import { JourneyController } from '../../controllers/journey-controller'
import * as action from '../actions/journey-actions'

export const concludeJourneyController = async (journeyId: number) => {
  const { key, token } = await makeAccess()
  const dataSource = new JourneyService(apiConfig(key, token))
  const repository = new JourneyRepository(dataSource)
  const control = new JourneyController(repository)
  const result = await control.concludeJourney(journeyId)
  return result
}

export function* concludeJourneySaga({ payload }: any): any {
  try {
    const { journeyId } = payload
    const ok: boolean = yield call(concludeJourneyController, journeyId)
    if (ok) {
      yield put(action.concludeJourneySuccess())
    } else {
      yield put(action.concludeJourneyError('No se pudo concluir la jornada'))
    }
  } catch (error: any) {
    yield put(action.concludeJourneyError(error.toString()))
  }
}
